module.exports = __webpack_public_path__ + "static/media/15.5c0ec419.png";